import { render, staticRenderFns } from "./DailyChallengeItem.vue?vue&type=template&id=c9464d1c&scoped=true"
import script from "./DailyChallengeItem.vue?vue&type=script&lang=js"
export * from "./DailyChallengeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9464d1c",
  null
  
)

export default component.exports